module.exports = __webpack_public_path__ + "img/bs-9.4b674440.jpg";